module.exports = __webpack_public_path__ + "static/img/14.a774f56.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/14.png
// module id = dBId
// module chunks = 0